import React, { Fragment, useEffect, useState } from 'react';
import { Image, LI, P, UL } from '../../../AbstractElements';
import { User, FileText, LogOut } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { Account, logout } from '../../../Constant';

// Build a clean monogram avatar (initials on a champagne-bronze gradient) as an
// inline SVG — matches the FARA brand accent. Used whenever the user has no
// uploaded profile photo, so it never shows a broken image.
const monogramAvatar = (rawName) => {
    const name = (rawName || 'User').trim();
    const initials = name
        .split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase() || 'U';
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'>
        <defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
            <stop offset='0' stop-color='#a6875a'/><stop offset='1' stop-color='#8a6d43'/>
        </linearGradient></defs>
        <rect width='80' height='80' rx='40' fill='url(#g)'/>
        <text x='50%' y='50%' dy='.35em' text-anchor='middle'
            font-family='Inter, Segoe UI, Arial, sans-serif' font-size='32' font-weight='600'
            letter-spacing='1' fill='#ffffff'>${initials}</text>
    </svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

const LogoutClass = () => {
    const Navigate = useNavigate();
    const authenticated = JSON.parse(localStorage.getItem('authenticated'));
    const auth0_profile = JSON.parse(localStorage.getItem('auth0_profile'));
    const [profile, setProfile] = useState('');
    const [name, setName] = useState('');
    const [role, setRole] = useState('Admin');

    useEffect(() => {
        const displayName = localStorage.getItem('userName') || localStorage.getItem('userEmail') || 'User';
        setName(displayName);
        setProfile(localStorage.getItem('profileURL') || monogramAvatar(displayName));
        setRole(localStorage.getItem('userRole') || 'Admin');
    }, []);

    const Logout = () => {
        localStorage.removeItem('profileURL');
        localStorage.removeItem('token');
        localStorage.removeItem('auth0_profile');
        localStorage.removeItem('Name');
        localStorage.removeItem('userName');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userId');
        localStorage.removeItem('userRole');
        localStorage.setItem('authenticated', false);
        localStorage.setItem('login', false);
        Navigate(`${process.env.PUBLIC_URL}/login`);
    };

    return (
        <Fragment>
            <LI attrLI={{ className: "profile-nav onhover-dropdown p-0" }} >
                <div className="d-flex profile-media">
                    <Image attrImage={{
                        className: 'b-r-50 m-0',
                        src: authenticated ? auth0_profile.picture : profile,
                        alt: name,
                        width: 40, height: 40, style: { objectFit: 'cover' },
                        onError: (e) => { e.currentTarget.src = monogramAvatar(name); },
                    }} />
                    <div className="flex-grow-1"><span>{authenticated ? auth0_profile.name : name}</span>
                        <P attrPara={{ className: "mb-0 font-roboto" }} >{role.charAt(0).toUpperCase() + role.slice(1)} <i className="middle fa fa-angle-down"></i></P>
                    </div >
                </div >
                <UL attrUL={{ className: "profile-dropdown onhover-show-div" }}>
                    <LI>
                        <Link to={`${process.env.PUBLIC_URL}/app/users/userProfile`}><User />{Account}</Link>
                    </LI>
                    <LI attrLI={{ onClick: Logout }}>
                        <Link to={`${process.env.PUBLIC_URL}/login`}><LogOut />{logout}</Link>
                    </LI>
                </UL>
            </LI >
        </Fragment >
    );
};

export default LogoutClass;